import React from "react";
import "./components.css";
import { Wand2 } from "lucide-react";

type Props = {
  open: boolean;
  onClose: () => void;
  onSelectGeneral: () => void;
  onSelectCSM: () => void;
  onSelectAE: () => void;
  onSelectPM: () => void;
  onSelectSWE: () => void;
  onSelectMKT: () => void;
};

const RoleSelectModal: React.FC<Props> = ({
  open,
  onClose,
  onSelectGeneral,
  onSelectCSM,
  onSelectAE,
  onSelectPM,
  onSelectSWE,
  onSelectMKT
}) => {
  if (!open) return null;

  const Tile: React.FC<{ title: string; blurb: string; onClick: () => void }> = ({ title, blurb, onClick }) => (
    <button
      className="card hoverable"
      onClick={onClick}
      style={{
        textAlign: "left",
        padding: 14,
        border: "1px solid #e5e7eb",
        borderRadius: 12,
        cursor: "pointer"
      }}
    >
      <div style={{ fontWeight: 700, marginBottom: 4 }}>{title}</div>
      <div className="small muted">{blurb}</div>
    </button>
  );

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Choose a Starter Prep Kit"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.35)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000
      }}
      onClick={onClose}
    >
      <div
        className="card"
        style={{
          width: "min(860px, 94vw)",
          padding: 16,
          borderRadius: 12,
          boxShadow: "0 16px 48px rgba(0,0,0,0.15)",
          background: "#fff"
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
          <Wand2 size={18} />
          <h3 style={{ margin: 0 }}>Choose a Starter Pack</h3>
        </div>
        <p className="muted small" style={{ marginTop: 0 }}>
        Pick the role you’re preparing for. We’ll create a Prep Kit with example notes and triggers. You can edit everything later.
        </p>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: 12,
            marginTop: 12
          }}
        >
          <Tile
            title="General"
            blurb="Core 10 for nearly any interview: Elevator Pitch, Why This Role, Strengths, STAR, Project Mgmt, Metrics."
            onClick={onSelectGeneral}
          />
          <Tile
            title="Customer Success (CSM)"
            blurb="Motivation & Fit, Define CS, Onboarding, Retention & Churn, Expansion, Outcomes/ROI, Goal Tracking, Product–Fit."
            onClick={onSelectCSM}
          />
          <Tile
            title="Account Executive (AE)"
            blurb="Strengths/Weaknesses (AE), Objection Handling, Prospecting, Relationships, CRM Fluency, Challenging Deals, Resilience."
            onClick={onSelectAE}
          />
          <Tile
            title="Product Manager (PM)"
            blurb="PM Role, User Focus, Improve Our Product, Influence Without Authority, Analytics, Research, Roadmap/Prioritization, Success."
            onClick={onSelectPM}
          />
          <Tile
            title="Software Engineer (SWE)"
            blurb="Hard Technical Problem, End-to-End Project, Debugging, Tools, Explaining to Non-Tech, Success Metrics, Performance, Why This Role."
            onClick={onSelectSWE}
          />
          <Tile
            title="Marketing"
            blurb="Favorite Campaign, What Makes Success, Improve Our Campaign, Biggest Win, Measurement, Channels, Budget Constraints, Revenue Impact."
            onClick={onSelectMKT}
          />
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 14 }}>
          <button className="button button-secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default RoleSelectModal;
